import { actionTypes as ToastsActionTypes } from 'modules/toastContainer/actionTypes';
import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';
import {
  CampaignStateDefinition,
  CampaignTypeDefinitions,
  MessageMedium,
} from 'modules/graphql/types';
import { ActionTypes } from '../ducks/actionTypes';

export type PaginationInput = {
  offset: number;
  limit: number;
  page: number;
};

export enum CampaignContributionTableHeader {
  CAMPAIGN = 'name',
  START_AT = 'startedAt',
  STATUS = 'state',
  SENDS = 'sends',
  DELIVERED = 'delivered',
  CONTRIBUTIONS = 'contributions',
  UNIQUE_CONTRIBUTIONS = 'uniqueContributions',
  MESSAGE_MEDIUM = 'messageMedium',
}

export enum CampaignContributionTableSort {
  CAMPAIGN = 'Name',
  START_AT = 'StartAt',
  STATUS = 'State',
  MESSAGE_MEDIUM = 'MessageMedium',
}

export type CampaignContributionTableHeaderAndSortMap = {
  [key in CampaignContributionTableHeader]?: CampaignContributionTableSort;
} & {
  [key in CampaignContributionTableSort]: CampaignContributionTableHeader;
};

export type SortInput = {
  sortBy: CampaignContributionTableSort;
  sortDirection: SORT_DIRECTIONS;
};

export type CampaignContributionQuery = {
  goalName: string;
  startTime: string;
  endTime: string;
  pagination: PaginationInput;
  sort: SortInput;
};

export type CampaignContributionsInfoData = {
  sends: number;
  count: number;
  offset: number;
  limit: number;
  page: number;
};

export interface CampaignContributionsResultsData {
  id: number;
  name: string;
  type: CampaignTypeDefinitions;
  startedAt: string;
  state: CampaignStateDefinition;
  sends: number;
  delivered: number;
  contributions: number;
  uniqueContributions: number;
  messageMedium: MessageMedium;
}

export interface CampaignContributionsCSVData
  extends Omit<CampaignContributionsResultsData, 'id' | 'delivered'> {
  link: string;
  delivered: string;
}

export type CampaignContributionsData = {
  info: CampaignContributionsInfoData;
  results: CampaignContributionsResultsData[];
  totalSends: number;
};

export type CampaignContributionsState = {
  data?: CampaignContributionsData;
  input: {
    sort: SortInput;
    pagination: PaginationInput;
  };
  loading: boolean;
  error: boolean;
};

export type CampaignContributionsPayload = Record<string, unknown>;

export type CampaignContributionsAction<T = Record<string, unknown>> = {
  type: ActionTypes | ToastsActionTypes;
  payload?: CampaignContributionsPayload;
} & T;

export type CampaignContributionsRowType = {
  row: CampaignContributionsResultsData;
};

export type CampaignContributionCSVExportQuery = {
  startTime: string;
  endTime: string;
  goalName: string;
  sort: {
    by: CampaignContributionTableSort;
    direction: SORT_DIRECTIONS;
  };
};
